export const mouseDemo = {
  trackingToggle: 'Mouse tracking',
  enabledLabel: 'enabled',
  disabledLabel: 'disabled',
  sequenceHint: '^[[?1000h',
  position: 'Position',
  button: 'Button',
  sequence: 'Sequence',
  bytesPrefix: 'Bytes:',
  buttons: ['Left', 'Middle', 'Right'],
  placeholders: {
    clickGrid: 'Click anywhere in the grid',
    enableTracking: 'Enable mouse tracking to capture clicks',
  },
  footer:
    "Most terminals I use don't emit mouse clicks until an app asks for tracking (e.g. ^[[?1000h — newer modes exist). Once enabled, grids of pixels become escape sequences carrying row/column.",
} as const;
